import { Button, type ButtonProps } from "@mantine/core";

interface Props {
  label: string;
  onClick: () => void;
  tabIndex?: number;
}

const Basic: React.FC<Props & ButtonProps> = ({
  label,
  fullWidth = true,
  ...rest
}) => {
  return (
    <Button
      className="h-full rounded-lg border-primary-light bg-primary-light py-3 font-inter text-gray-400 text-lg hover:bg-primary-lighter hover:text-gray-400"
      fullWidth={fullWidth}
      variant={"default"}
      {...rest}
    >
      {label}
    </Button>
  );
};

export default Basic;
